import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { default: String, storageKey: String, dark: Boolean }

  connect() {
    const storedView = this.storedView()
    const defaultView = storedView || this.defaultValue || this.tabTargets[0]?.dataset.view
    if (defaultView) {
      this.showView(defaultView)
    }
  }

  select(event) {
    event.preventDefault()
    const view = event.currentTarget.dataset.view
    this.showView(view)
  }

  showView(viewName) {
    if (!viewName) return

    this.tabTargets.forEach(tab => {
      const isActive = tab.dataset.view === viewName
      if (this.darkValue) {
        // Dark theme styling (beige-800 background)
        if (isActive) {
          tab.classList.remove("text-beige-300", "hover:text-white", "hover:bg-beige-700/50")
          tab.classList.add("text-white", "bg-beige-700")
        } else {
          tab.classList.remove("text-white", "bg-beige-700")
          tab.classList.add("text-beige-300", "hover:text-white", "hover:bg-beige-700/50")
        }
      } else {
        // Default light theme
        tab.classList.toggle("tab-active", isActive)
        tab.classList.toggle("tab-inactive", !isActive)
      }
    })

    this.panelTargets.forEach(panel => {
      const isActive = panel.dataset.view === viewName
      panel.classList.toggle("hidden", !isActive)
    })

    this.persistView(viewName)
  }

  storedView() {
    if (!this.hasStorageKeyValue) return null
    try {
      return window.localStorage.getItem(this.storageKeyValue)
    } catch (_) {
      return null
    }
  }

  persistView(viewName) {
    if (!this.hasStorageKeyValue) return
    try {
      window.localStorage.setItem(this.storageKeyValue, viewName)
    } catch (_) {
      // Ignore storage errors (private mode, blocked storage, etc.)
    }
  }
}
